export const MONTHS_IN_YEAR = 12;

export const ANIMATION_DURATION = 200;
export const INITIAL_HEIGHT = 188;

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const ENTRY_POINT_TIMEOUT = 10000;

// Amounts shown in the DD prompt copy.
export const DD_PROMPT_MIN_DIRECT_DEPOSIT_AMOUNT = '$800';
export const DD_PROMPT_MAX_ADVANCE_LIMIT = '$1,000';

// Used in Employment Info screen
export const REFETCH_QUERY_INTERVAL = 3000;
export const MAX_RETRIES = 5;

// Used for the linked account flow
export const LINKED_ACCOUNT_TIMEOUT_MILLISECONDS = 45000;
export const LINKED_ACCOUNT_PROCESSING_LIMIT_SECONDS = 30;
export const LINKED_ACCOUNT_ANALYZING_MESSAGING_LIMIT_SECONDS = 15;
export const MINIMUM_POLLING_TIME_MILLISECONDS = 7000;
export const CALCULATED_MINIMUM_POLLING_TIME =
  (LINKED_ACCOUNT_TIMEOUT_MILLISECONDS - MINIMUM_POLLING_TIME_MILLISECONDS) /
  1000;
